"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('geometric-flowers', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("ellipse", {
    cx: "17.6777",
    cy: "17.6778",
    rx: "9",
    ry: "16",
    transform: "rotate(-45 17.6777 17.6778)",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("ellipse", {
    rx: "9",
    ry: "16",
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 17.6777 31.3784)",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("ellipse", {
    rx: "9",
    ry: "16",
    transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 31.3223 17.6778)",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("ellipse", {
    cx: "31.3223",
    cy: "31.3784",
    rx: "9",
    ry: "16",
    transform: "rotate(135 31.3223 31.3784)",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;